<template>

    <div class="d-flex w-100 border px-35 py-3 mt-3 custom-accordion" v-if="discount == 0">
        <div class="codice-sconto w-100">
            <div class="d-flex W-100 align-items-center cursor-pointer" @click="discount_box_is_open = !discount_box_is_open">
                <div class="flex-grow-1 h7 text-uppercase mb-0">
                    <span v-if="lang == 'it'">
                        Hai un codice sconto?
                    </span>
                    <span v-else>
                        Do you have a discount code?
                    </span>
                </div>
                <div>
                    <img alt="icona" :class="{'rotate-up' : discount_box_is_open}" width="10" src="/images/becco-giu-dark.svg"/>
                </div>
            </div>

            <div class="expanded-content" :style="discount_box_is_open ? 'height:' + (panel_height + error_offset) + 'px' : 'height:0px'" :class="{'expand' : discount_box_is_open}">

                <div class="form-wrapper mt-2 mb-4">
                    <input type="text" required @focus="validation.discount.state = null, error_offset = 0" v-model="discount_code"  autocomplete="off" placeholder=" " value="" class="form-control"/>
                    <label class="placeholder">{{$root.translateString('code')}}</label>
                    <div class="pristine-error" :class="validation.discount.state == false ? 'invalid' : 'd-none'">{{validation.discount.message}}</div>
                </div>

                <a class="btn btn-primary btn-primary--empty mb-2" href="javascript:void(0)" @click="applyDiscount">
                    <span>{{$root.translateString('apply_code')}}</span>
                </a>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        props: ['discount', 'lang'],
        data() {
            return {
                discount_code: '',
                discount_box_is_open: true,
                panel_height: 'auto',
                error_offset: 0,
                validation: {
                    discount: {
                        state: null,
                        message: ''
                    }
                }
            }
        },
        mounted() {
            // this.panel_height = document.querySelector('.expanded-content').offsetHeight - 30;
            // this.discount_box_is_open = false;

            // document.addEventListener('resize', () => {
            //     this.panel_height = document.querySelector('.expanded-content').offsetHeight - 30;
            // })
        },
        methods: {
            applyDiscount()
            {
                if(this.discount_code == "") {
                    this.validation.discount.state = false;
                    if(this.lang == 'it') {
                        this.validation.discount.message = 'Devi inserire un codice valido';
                    }else{
                        this.validation.discount.message = 'Your code is invalid';
                    }
                    this.error_offset = 30;
                    return
                }

                axios.post('/api/cart/discount', {
                    code: this.discount_code
                })
                    .then(response => {

                        if(!response.data.success) {
                            if(this.lang == "it") {
                                this.validation.discount.message = 'Il codice inserito non è valido';
                            }else{
                                this.validation.discount.message = 'Your code is invalid';
                            }
                            this.validation.discount.state = false;
                            this.error_offset = 30;
                        }else{
                            this.error_offset = 0;
                            this.$eventHub.$emit('discount.applied');
                        }

                    })
            },
        },
        beforeDestroy() {

        },
    }
</script>
